import React, { Fragment, useState } from "react";
import LevelTd from "./LevelTd";
import Quotables from "./Quotables";
import Link from "../../Link";
import Expander from "../../Expander";

export default function QuotableGroup({
  quotable,
  isDisabled = false,
  isVisible,
  renderCheckbox,
  renderPrice,
}) {
  const [collapsed, setCollapsed] = useState(quotable.collapsed);
  const disabled = isDisabled(quotable);

  return (
    <Fragment>
      <tr>
        <td className="center">{renderCheckbox(quotable)}</td>
        <LevelTd colSpan={5} level={quotable.level} disabled={disabled}>
          <Link onClick={() => setCollapsed(!collapsed)}>
            <Expander expanded={!collapsed} />
            {quotable.name}
          </Link>
        </LevelTd>
        <td className="center">{quotable.can_add_to_sample && renderPrice(quotable)}</td>
      </tr>
      {!collapsed && (
        <Quotables
          quotables={quotable.quotables}
          isDisabled={disabled ? () => true : isDisabled}
          isVisible={isVisible}
          renderCheckbox={renderCheckbox}
          renderPrice={renderPrice}
        />
      )}
    </Fragment>
  );
}
